import type { ParkKey } from "../../src/types";

const THEME_PARK_SLUGS: Record<string, ParkKey> = {
  "magic-kingdom": "magic-kingdom",
  epcot: "epcot",
  "hollywood-studios": "hollywood-studios",
  "animal-kingdom": "animal-kingdom",
  "disney-springs": "disney-springs",
};

const WATER_PARK_SLUGS = new Set(["typhoon-lagoon", "blizzard-beach"]);

const RESORT_SLUG_HINTS = ["resort", "lodge", "villas", "inn", "campground", "fort-wilderness"];

export function parkFromUrl(url: string): ParkKey {
  const segments = url.split("/").filter(Boolean);
  const i = segments.indexOf("dining");
  if (i < 0 || i + 1 >= segments.length) return "other";
  const slug = segments[i + 1];
  if (THEME_PARK_SLUGS[slug]) return THEME_PARK_SLUGS[slug];
  if (WATER_PARK_SLUGS.has(slug)) return "water-park";
  if (RESORT_SLUG_HINTS.some((h) => slug.includes(h))) return "resort";
  return "other";
}

const DISPLAY_NAMES: Record<ParkKey, string> = {
  "magic-kingdom": "Magic Kingdom",
  epcot: "EPCOT",
  "hollywood-studios": "Hollywood Studios",
  "animal-kingdom": "Animal Kingdom",
  "disney-springs": "Disney Springs",
  resort: "Resort hotel",
  "water-park": "Water park",
  other: "Other",
};

export function parkDisplayName(park: ParkKey): string {
  return DISPLAY_NAMES[park];
}
